// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eF","newsTag":"eF","dafalut":"eG","qishou":"eH","shangjia":"eI","shehui":"eJ","caiwu":"eK","piyao":"eL","suanfa":"eM","keji":"eN","lingshou":"eO","gongzuo":"eP"};